import * as actionTypes from "./actionTypes";
import { reportService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function getDailyBalance({
  page = constants.GET_ALL_ITEMS,
  store,
  selectedDate,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_DAILY_BALANCE });

      dispatch({ type: actionTypes.FETCH_DAILY_BALANCE });

      const response = await reportService.getDailyBalance(
        page,
        store,
        selectedDate
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_DAILY_BALANCE_SUCCESS,
        payload: {
          dailyBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
          totalCreditNotes: data.totalCreditNotes,
          totalCashPayed: data.totalCashPayed,
          totalCardPayed: data.totalCardPayed,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_DAILY_BALANCE_FAILURE
      );
    }
  };
}

export function getEmployeesBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_EMPLOYEES_BALANCE });

      dispatch({ type: actionTypes.FETCH_EMPLOYEES_BALANCE });

      const response = await reportService.getEmployeesBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_EMPLOYEES_BALANCE_SUCCESS,
        payload: {
          employeesBalance: data.data,
          totalSell: data.totalSell,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_EMPLOYEES_BALANCE_FAILURE
      );
    }
  };
}

export function getReceiptBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_RECEIPT_BALANCE });

      dispatch({ type: actionTypes.FETCH_RECEIPT_BALANCE });

      const response = await reportService.getReceiptBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_RECEIPT_BALANCE_SUCCESS,
        payload: {
          receiptBalance: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_RECEIPT_BALANCE_FAILURE
      );
    }
  };
}

export function getReceiptSellsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_RECEIPT_SELLS_BALANCE });

      dispatch({ type: actionTypes.FETCH_RECEIPT_SELLS_BALANCE });

      const response = await reportService.getReceiptSellsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_RECEIPT_SELLS_BALANCE_SUCCESS,
        payload: {
          receiptSellsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_RECEIPT_SELLS_BALANCE_FAILURE
      );
    }
  };
}

export function getCategoryBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_CATEGORY_BALANCE });

      dispatch({ type: actionTypes.FETCH_CATEGORY_BALANCE });

      const response = await reportService.getCategoryBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_CATEGORY_BALANCE_SUCCESS,
        payload: {
          categoryBalance: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_CATEGORY_BALANCE_FAILURE
      );
    }
  };
}

export function getCategorySellsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_CATEGORY_SELLS_BALANCE });

      dispatch({ type: actionTypes.FETCH_CATEGORY_SELLS_BALANCE });

      const response = await reportService.getCategorySellsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_CATEGORY_SELLS_BALANCE_SUCCESS,
        payload: {
          categorySellsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_CATEGORY_SELLS_BALANCE_FAILURE
      );
    }
  };
}

export function getPaymentDetailsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_PAYMENT_DETAILS_BALANCE });
      dispatch({ type: actionTypes.FETCH_PAYMENT_DETAILS_BALANCE });

      const response = await reportService.getPaymentDetailsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PAYMENT_DETAILS_BALANCE_SUCCESS,
        payload: {
          paymentDetailsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PAYMENT_DETAILS_BALANCE_FAILURE
      );
    }
  };
}

export function getPaymentTypesBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_PAYMENT_TYPES_BALANCE });

      dispatch({ type: actionTypes.FETCH_PAYMENT_TYPES_BALANCE });

      const response = await reportService.getPaymentTypesBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PAYMENT_TYPES_BALANCE_SUCCESS,
        payload: {
          paymentTypesBalance: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PAYMENT_TYPES_BALANCE_FAILURE
      );
    }
  };
}

export function getOfferDetailsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_OFFER_DETAILS_BALANCE });
      dispatch({ type: actionTypes.FETCH_OFFER_DETAILS_BALANCE });

      const response = await reportService.getOfferDetailsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_OFFER_DETAILS_BALANCE_SUCCESS,
        payload: {
          offerDetailsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_OFFER_DETAILS_BALANCE_FAILURE
      );
    }
  };
}

export function getServiceDetailsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_SERVICE_DETAILS_BALANCE });
      dispatch({ type: actionTypes.FETCH_SERVICE_DETAILS_BALANCE });

      const response = await reportService.getServiceDetailsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_SERVICE_DETAILS_BALANCE_SUCCESS,
        payload: {
          serviceDetailsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_SERVICE_DETAILS_BALANCE_FAILURE
      );
    }
  };
}

export function getServiceNamesBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_SERVICE_NAMES_BALANCE });

      dispatch({ type: actionTypes.FETCH_SERVICE_NAMES_BALANCE });

      const response = await reportService.getServiceNamesBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_SERVICE_NAMES_BALANCE_SUCCESS,
        payload: {
          serviceNamesBalance: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_SERVICE_NAMES_BALANCE_FAILURE
      );
    }
  };
}

export function getDaysBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_DAYS_BALANCE });

      dispatch({ type: actionTypes.FETCH_DAYS_BALANCE });

      const response = await reportService.getDaysBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_DAYS_BALANCE_SUCCESS,
        payload: {
          daysBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_DAYS_BALANCE_FAILURE
      );
    }
  };
}

export function getCustomersBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_CUSTOMERS_BALANCE });

      dispatch({ type: actionTypes.FETCH_CUSTOMERS_BALANCE });

      const response = await reportService.getCustomersBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_CUSTOMERS_BALANCE_SUCCESS,
        payload: {
          customersBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_CUSTOMERS_BALANCE_FAILURE
      );
    }
  };
}

export function getProductDetailsBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_PRODUCT_DETAILS_BALANCE });
      dispatch({ type: actionTypes.FETCH_PRODUCT_DETAILS_BALANCE });

      const response = await reportService.getProductDetailsBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PRODUCT_DETAILS_BALANCE_SUCCESS,
        payload: {
          productDetailsBalance: data.data,
          totalBought: data.totalBought,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCT_DETAILS_BALANCE_FAILURE
      );
    }
  };
}

export function getProductNamesBalance({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_PRODUCT_NAMES_BALANCE });

      dispatch({ type: actionTypes.FETCH_PRODUCT_NAMES_BALANCE });

      const response = await reportService.getProductNamesBalance(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PRODUCT_NAMES_BALANCE_SUCCESS,
        payload: {
          productNamesBalance: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCT_NAMES_BALANCE_FAILURE
      );
    }
  };
}

export function getInternalConsumption({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_INTERNAL_CONSUMPTION });
      dispatch({ type: actionTypes.FETCH_INTERNAL_CONSUMPTION });
      const response = await reportService.getInternalConsumption(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_INTERNAL_CONSUMPTION_SUCCESS,
        payload: {
          internalConsumption: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_INTERNAL_CONSUMPTION_FAILURE
      );
    }
  };
}

export function getRegularizations({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_REGULARIZATIONS });
      dispatch({ type: actionTypes.FETCH_REGULARIZATIONS });
      const response = await reportService.getRegularizations(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_REGULARIZATIONS_SUCCESS,
        payload: {
          regularizations: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_REGULARIZATIONS_FAILURE
      );
    }
  };
}

export function getProductsIn({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_PRODUCTS_IN });
      dispatch({ type: actionTypes.FETCH_PRODUCTS_IN });
      const response = await reportService.getProductsIn(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PRODUCTS_IN_SUCCESS,
        payload: {
          productsIn: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCTS_IN_FAILURE
      );
    }
  };
}
export function getProductsDevolutions({
  startDate,
  endDate,
  page = constants.GET_ALL_ITEMS,
  store,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true)
        dispatch({ type: actionTypes.RESET_PRODUCTS_DEVOLUTIONS });
      dispatch({ type: actionTypes.FETCH_PRODUCTS_DEVOLUTIONS });
      const response = await reportService.getProductsDevolutions(
        page,
        startDate,
        endDate,
        store
      );
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PRODUCTS_DEVOLUTIONS_SUCCESS,
        payload: {
          productsDevolutions: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCTS_DEVOLUTIONS_FAILURE
      );
    }
  };
}

export function getInventory({
  storeId,
  page = constants.GET_ALL_ITEMS,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_INVENTORY });
      dispatch({ type: actionTypes.FETCH_INVENTORY });
      const response = await reportService.getInventory(page, storeId);
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_INVENTORY_SUCCESS,
        payload: {
          inventory: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_INVENTORY_FAILURE);
    }
  };
}

export function getDetailedSellsReport({
  startDate,
  endDate,
  storeId,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) {
        dispatch({ type: actionTypes.RESET_FETCH_DETAILED_SELLS });
        return;
      }
      dispatch({ type: actionTypes.FETCH_DETAILED_SELLS });
      const response = await reportService.getDetailedSells(
        startDate,
        endDate,
        storeId
      );
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_DETAILED_SELLS_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_DETAILED_SELLS_SUCCESS,
        payload: { value: data },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_DETAILED_SELLS_FAILURE
      );
    }
  };
}

export function resetDetailedSellsReport() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BULK_LOAD_CUSTOMERS_RESET,
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/report/actions.js